import { clearButtonStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

clearButtonStyles.clearButton = {
    css: css`
        float: right;
        background: #ffffff;
        border: 2px solid ${getColor("primary")};
        border-radius: unset;
        padding: 10px 34px;
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            font-size: ${TYPOGRAPHY.size.smaller};
        }
        &:hover {
            background: #ffffff;
        }
    `,
};
